import React, { createContext, useContext } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const default_error = 'An unexpected error occurred. Please try again later.';

const MessageType = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  EXCEPTION: 'EXCEPTION',
};

const defaultToastConfig = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

const ToastHandlerContext = createContext();

export const ToastHandlerProvider = ({ children }) => {
  const handleToast = (content) => {
    toast.dismiss();

    const message = content?.message || default_error;
    const type = content?.type || MessageType.ERROR;

    const options = { ...defaultToastConfig };

    switch (type) {
      case MessageType.INFO:
        toast.info(message, options);
        break;
      case MessageType.SUCCESS:
        toast.success(message, options);
        break;
      case MessageType.WARNING:
        toast.warning(message, options);
        break;
      case MessageType.EXCEPTION:
      case MessageType.ERROR:
        toast.error(message, options);
        break;
      default:
        toast.error(default_error, options);
        break;
    }
  };

  return (
    <ToastHandlerContext.Provider value={{ handleToast }}>
      {children}
      <ToastContainer />
    </ToastHandlerContext.Provider>
  );
};

export const useToastHandler = () => {
  const context = useContext(ToastHandlerContext);
  if (!context) {
    throw new Error('useToastHandler must be used within ToastHandlerProvider');
  }
  return context;
};
